// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"339":"css/report","358":"css/app-shift"}[chunkId] + ".css";
};